<body>
  <div class="main-container" [ngStyle]="{ 'background-color': bgColor, color: ftColor }">
    <button type="button" class="button-modal" (click)="config = true">
      <fa-icon [icon]="faFilter"></fa-icon>
      Selecionar Doca
    </button>
    <div class="exibition-container" [ngStyle]="{ 'background-color': bgColor, color: ftColor }">

      <!-- Nome da Doca -->
      <app-dock [dock]="dock" [ngStyle]="{'color' : activeTrip ? '#fff' : '#000'}"></app-dock>

      <!-- Exibe app-takt somente se houver viagem ativa -->
      <ng-container *ngIf="activeTrip; else proximaViagemTemplate">
        <app-takt [takt]="takt" [bgColor]="bgColor"></app-takt>
      </ng-container>

      <div class="general-container">
        <!-- Informações da viagem ativa -->
        <ng-container *ngIf="activeTrip">
          <div class="box-start">
            <div *ngIf="activeTrip.extra == null" class="box-start-card-top">
              <p class="box-title">Chegada Prevista:</p>
              <p class="box-data">{{ activeTrip.inicioLCB || 'N/A' }}</p>
            </div>
            <div class="box-start-card-bottom">
              <p class="box-title">Chegada Real:</p>
              <p class="box-data">{{ formatarNumero(selectedDock?.status?.getHours()) }}:{{
                formatarNumero(selectedDock?.status?.getMinutes()) }}</p>
            </div>
          </div>

          <div class="box-info" [ngClass]="{ 'centered-box-info': activeTrip.extra != null }">
            <p *ngIf="activeTrip.extra == null" class="destino">Viagem {{ activeTrip.viagem || '' }}
            <p class="destino">{{ activeTrip.destino || '' }} {{ activeTrip.tipo || '' }}</p>
          </div>

          <div class="box-finish" *ngIf="activeTrip.extra == null">
            <div class="box-finish-card-top">
              <p class="box-title">Saída Prevista:</p>
              <p class="box-data">{{ activeTrip.saidaLCB || 'N/A' }}</p>
            </div>
            <div class="box-finish-card-bottom">
              <p class="box-title">Saída Real:</p>
              <p class="box-data">{{ saidaReal }}</p>
            </div>
          </div>
        </ng-container>

        <!-- Template para próxima viagem -->
        <ng-template #proximaViagemTemplate>
          <div class="rainbow">
            <p class="rainbow-gap" *ngIf="nextTrip; else noNextTrip">
              <span class="next-trip">Próxima viagem:</span>
              <strong class="divider"></strong>
              <span class="trip-description">
                <ng-container *ngIf="nextTrip.extra == null; else tripType">
                  <strong class="trip-number"> {{ nextTrip.viagem }}</strong>
                  <br> Chegada: {{ nextTrip.inicioLCB }}
                </ng-container>
                <ng-template #tripType>
                  {{ nextTrip.tipo }}
                </ng-template>
              </span>
            </p>
          </div>
        </ng-template>

        <!-- Template sem viagens -->
        <ng-template #noNextTrip>
          <p class="rainbow-gap">
            {{ dockId != 0 ? 'Não há viagens na fila' : 'Escolha uma doca' }}
          </p>
        </ng-template>

      </div>
    </div>
  </div>
  <div class="container-modal" *ngIf="config">
    <div class="modal-dock">
      <h3 class="modal-title">Escolha uma doca</h3>
      <select class="form-control" type="number" [(ngModel)]="selectedDock" (ngModelChange)="changeDock($event)">
        <option *ngFor="let selected of docksOption$ | async" [ngValue]="selected.id">
          <p class="description">{{ selected.description }}</p>
        </option>
      </select>
      <button class="modal-icon" (click)="config = false">x</button>
    </div>
  </div>
</body>
